import { render, staticRenderFns } from "./PlaylistPlayer.vue?vue&type=template&id=cb1c07fe&scoped=true"
import script from "./PlaylistPlayer.vue?vue&type=script&lang=js"
export * from "./PlaylistPlayer.vue?vue&type=script&lang=js"
import style0 from "./PlaylistPlayer.vue?vue&type=style&index=0&id=cb1c07fe&lang=scss&scoped=true"
import style1 from "./PlaylistPlayer.vue?vue&type=style&index=1&id=cb1c07fe&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1c07fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb1c07fe')) {
      api.createRecord('cb1c07fe', component.options)
    } else {
      api.reload('cb1c07fe', component.options)
    }
    module.hot.accept("./PlaylistPlayer.vue?vue&type=template&id=cb1c07fe&scoped=true", function () {
      api.rerender('cb1c07fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/player/PlaylistPlayer.vue"
export default component.exports